import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilters } from '@views/CustomDashboards/CustomDashboardContext';
import { PAGE_PATHS, Permission } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/')({
  validateSearch: zodValidator(withDefaults(schema.CUSTOM_DASHBOARDS, defaultFilters)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!(
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CUSTOM_DASHBOARDS }) ||
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CUSTOM_DASHBOARDS, permission: Permission.UPDATE })
    );
    context.validatePermissions({ isAllowed, preload });
  },
});
